<template>
	<div>
		{{ instruction }}
	</div>
</template>
<script>
export default {
	props: {
		instruction: {
			required: true,
			type: Object,
		},
	},
};
</script>
